import { Timeframe } from "@opensea/graphql"
import { toLowerCase, toUpperCase } from "@opensea/utils"
import { parseAsStringLiteral, useQueryState } from "nuqs"
import { QUERY_PARAM_KEYS } from "./keys"

const parser = parseAsStringLiteral(Timeframe.map(v => toLowerCase(v)))

export function useAnalyticsTimeframeQueryParam() {
  const [timeframe, setTimeframe] = useQueryState(
    QUERY_PARAM_KEYS.timeframe,
    parser.withDefault("seven_days"),
  )

  return { timeframe: toUpperCase(timeframe), setTimeframe }
}
